import React, { createContext, useState, useCallback } from 'react';
import axios from 'axios';

export const MEE6GuildContext = createContext();

export const MEE6GuildProvider = ({ children }) => {
  const [guilds, setGuilds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchGuilds = useCallback(async () => {
    setIsLoading(true);
    const token = localStorage.getItem("isha_token");
    const config = {
      headers: { Authorization: `${token}` },
    };

    try {
      const response = await axios.get('/api/mee6_guilds', config);
      setGuilds(response.data.guilds);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, []);

  return (
    <MEE6GuildContext.Provider value={{ guilds, isLoading, fetchGuilds }}>
      {children}
    </MEE6GuildContext.Provider>
  );
};
